import { makeStyles } from "@material-ui/core";
import howAreWeDifferent1 from '../../assets/logo/trackLogos/howAreWeDifferent1.svg';
import howAreWeDifferent2 from '../../assets/logo/trackLogos/howAreWeDifferent2.svg';
import howAreWeDifferent3 from '../../assets/logo/trackLogos/howAreWeDifferent3.svg';
import howAreWeDifferent4 from '../../assets/logo/trackLogos/howAreWeDifferent4.svg';
import howAreWeDifferent5 from '../../assets/logo/trackLogos/howAreWeDifferent5.svg';
import howAreWeDifferent6 from '../../assets/logo/trackLogos/howAreWeDifferent6.svg';
import howAreWeDifferent7 from '../../assets/logo/trackLogos/howAreWeDifferent7.svg';
import howAreWeDifferent8 from '../../assets/logo/trackLogos/howAreWeDifferent8.svg';
import howAreWeDifferent9 from '../../assets/logo/trackLogos/howAreWeDifferent9.svg';
import React from "react";


const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
        width: '100%',
        background: '#315CD5 !important',
        color: '#fff'
    },
    pointersContainer: {
        [theme.breakpoints.down("md")]: {
            maxWidth: '100%',
        },
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '1rem',
        margin: 'auto',
        maxWidth: '90%',
    },
    subPointersContainer: {
        [theme.breakpoints.down("md")]: {
            width: '24rem'
        },
        display: 'flex',
        width: '30rem',
        textAlign: 'start',
        gap: '1rem',
        alignItems: 'center',
    }
}))

const HowAreWeDiffrent = () => {

    const classes = useStyles();

    const data = [
        { img: howAreWeDifferent1, boldText: 'Join at any time.', text: 'We don’t have a cohort system, so you can join when you want.' },
        { img: howAreWeDifferent2, boldText: 'Retake classes as many times as needed.', text: 'We review, evaluate and find your weak points, to dedicate most of your effort to the knowledge you need the most.' },
        { img: howAreWeDifferent3, boldText: 'Unique teaching system.', text: 'We developed a 9-step-system design for faster learning with proven results.' },
        { img: howAreWeDifferent4, boldText: 'Apply to open positions.', text: 'On our platform, we line up interviews with top tech companies from our network that you can apply for.' },
        { img: howAreWeDifferent5, boldText: 'Qualified instructors.', text: 'Variety of coaches based on the level you are targeting.' },
        { img: howAreWeDifferent6, boldText: 'Co-pilot.', text: 'We are with you through the whole process till the moment you get your job!' },
        { img: howAreWeDifferent7, boldText: '1-on-1.', text: 'We provide unlimited 1-on-1 sessions throughout all the preparation journey.' },
        { img: howAreWeDifferent8, boldText: '100% success - ', text: 'if they follow our plan.' },
        { img: howAreWeDifferent9, boldText: 'AI Assistant.', text: 'On top of our instructors, you have special ChatGPT assistant to answer your questions regarding job-preparation interviews.' },
    ]

    return (
        <section className={classes.root}>
            <h1>How we are different?</h1>
            <div className={classes.pointersContainer}>
                {data.map((val, idx) => (
                    <div className={classes.subPointersContainer} key={val.boldText + idx}>
                        <img src={val.img} />
                        <p><b>{val.boldText}</b> {val.text}</p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default HowAreWeDiffrent;